import { PAGINATION } from '../constants/Define';
import * as Types from '../constants/Types';

const initialState = {
    isUpdating: false,
    dataList: [],
    isFetching: false,
    Detail : null,
    TranslateDetail : null,
    ProductDetail : null,
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    totalPage: 0,
    tab: 1,
};

export default (state = initialState, action) => {
    switch (action.type) {
      case Types.PACKAGE_RATE_ACTION:
        return { ...state, isFetching: true, dataList: [] };
      case Types.PACKAGE_RATE_SUCCESS:
        return {
          ...state,
          dataList: action.data.packageRates,
          isFetching: false,
          isUpdating: false,
          pageSize: action.data.limit,
          pageIndex: Math.floor(action.data.offset/action.data.limit) + 1,
          totalCount: action.data.total,
        };

      case Types.PACKAGE_RATE_DETAIL_ACTION:
      case Types.PACKAGE_RATE_GET_TRANSLATE_ACTION:
      case Types.PACKAGE_RATE_GET_PRODUCT_ACTION:
        return { ...state, isFetching: true };
      case Types.PACKAGE_RATE_DETAIL_SUCCESS:
        return { ...state, isFetching: false, isUpdating: false, Detail: action.result };
      case Types.PACKAGE_RATE_CREATE_ACTION:
      case Types.PACKAGE_RATE_UPDATE_ACTION:
      case Types.PACKAGE_RATE_UPDATE_ACTIVE_ACTION:
      case Types.PACKAGE_RATE_DELETE_ACTION:
      case Types.PACKAGE_RATE_CLONE_ACTION:
      case Types.PACKAGE_RATE_CREATE_TRANSLATE_ACTION:
      case Types.PACKAGE_RATE_UPDATE_TRANSLATE_ACTION:
      case Types.PACKAGE_RATE_CREATE_PRODUCT_ACTION:
      case Types.PACKAGE_RATE_UPDATE_PRODUCT_ACTION:
          return { ...state, isUpdating: true };
      case Types.PACKAGE_RATE_GET_TRANSLATE_SUCCESS:
        return { ...state, TranslateDetail: action.result, isFetching: false, isUpdating: false };
      case Types.PACKAGE_RATE_GET_PRODUCT_SUCCESS:
        return { ...state, ProductDetail: action.result, isFetching: false, isUpdating: false };
      case Types.PACKAGE_RATE_CREATE_SUCCESS:
        return { ...state, isUpdating: false };
      case Types.PACKAGE_RATE_TAB_ACTION:
        return { ...state, tab: action.result };
      case Types.PACKAGE_RATE_FAIL:
        return {
          ...state,
          isFetching: false,
          isUpdating: false,
        };
      case Types.PACKAGE_RATE_RESET_DETAIL:
        return { ...state, Detail: null, TranslateDetail: null, ProductDetail: null };
      default:
        return state;
    }
}
